/**************************************************
 * Nombre:       Detalle_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Box, Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo.mp4'
import fondo_img from '../../../Recursos/fondo_img.png'
import ic_agua from '../../../Recursos/ic_agua.svg'
import ic_almoada from '../../../Recursos/ic_almoada.svg'
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Reserva from "../../Dialogos/Dialogo_Reserva";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Detalle_Descripcion from "../../Tarjetas/Tarjeta_Detalle_Descripcion";
import Tarjeta_Caracteristicas from "../../Tarjetas/Tarjeta_Caracteristicas";
import {EventAvailable} from '@mui/icons-material'
import {useEffect, useState} from "react";


const Detalle_Portada = ({item}) => {
    const {sCell, sTab, masSM} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Reserva})
    const [fotos, setFotos] = useState([])
    const [caractaristicas, setCaractaristicas] = useState([])

    useEffect(() => {

        console.log(item)
        if (item && item.imgs) {
            setFotos(item.imgs)
            if (item.caracteristicas) {
                setCaractaristicas(item.caracteristicas)
            }

        }

    }, [item])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <video width={'100%'} height={sCell ? 667 : sTab ? 631 : 630}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1
                   }}
                   id="background-video" autoPlay loop muted poster={fondo_img}>
                <source src={fondo} type="video/mp4"/>
            </video>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? -83.5 : -79, zIndex: 2}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        height: sCell ? 670 : sTab ? 650 : 632,
                        background: 'linear-gradient(180deg, #000 0%, rgba(11, 39, 42, 0.05) 28.37%, #0B272A 100%)',
                        width: '100%'
                    }}
                >

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
                    >

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >


                            <Grid container size={{xs: 12, sm: 12, md: 9}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 15 : 14}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{
                                        borderRadius: sCell ? '12px 12px 12px 12px' : '12px 53px 12px 12px',
                                        border: '1px solid rgba(255, 255, 255, 0.41)',
                                        background: 'rgba(255, 255, 255, 0.10)',
                                        backdropFilter: 'blur(8px)'
                                    }}
                                >


                                    <Grid container size={{xs: 12, sm: 5, md: 5}} sx={{justifyContent: 'flex-start'}}>
                                        {fotos.length > 0 &&
                                            <Splide
                                                //ref={refe}
                                                aria-label="My Favorite Images" style={{width: '100%'}}
                                                options={{
                                                    autoplay: true,
                                                    speed: 1500,
                                                    rewind: true,
                                                    perPage: 1,
                                                    arrows: true,
                                                    perMove: 1,
                                                    pagination: true,
                                                    width: '100%',
                                                    drag: 'free',
                                                    snap: true,
                                                    interval: 8000,
                                                    focus: 'center',
                                                    type: 'fade',
                                                    padding: '0rem',
                                                    gap: 20,
                                                }}
                                            >

                                                {fotos.map((item, index) => {
                                                    return (
                                                        <SplideSlide key={`qer${index}`}>

                                                            <Box sx={{
                                                                width: '100%',
                                                                height: sCell ? 540 : sTab ? 715 : 630,
                                                                borderRadius: sCell ? '12px 12px 0px 0px' : '12px 0px 0px 12px',
                                                                borderColor: '#000',
                                                                backgroundImage: `url(${item})`,
                                                                backgroundRepeat: 'no-repeat',
                                                                backgroundSize: 'cover',
                                                            }}>


                                                            </Box>

                                                        </SplideSlide>
                                                    )
                                                })}


                                            </Splide>

                                        }
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{justifyContent: 'flex-start'}}>
                                        <Grid
                                            container
                                            justifyContent={'flex-start'}
                                            alignItems={'center'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            sx={{px: !masSM ? 4 : 6, py: sCell ? 4 : 6}}
                                        >

                                            <Grid container size={{xs: 12, sm: 12, md: 6}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <Typography
                                                    sx={{fontSize: !masSM ? 32 : 40, fontWeight: 800, lineHeight: 1.1}}>
                                                    {`Suite ${item?.numero}`}
                                                </Typography>
                                            </Grid>

                                            <Grid container size={{xs: 12, sm: 12, md: 6}}
                                                  sx={{justifyContent: !masSM ? 'flex-start' : 'flex-end'}}>
                                                <Typography sx={{
                                                    fontSize: 18,
                                                    fontWeight: 400,
                                                    textAlign: sCell ? 'left' : 'right',
                                                    lineHeight: 1.1
                                                }}>Tu
                                                    suite con tecnología biohacking</Typography>
                                            </Grid>

                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                                sx={{mt: 2}}
                                            >

                                                {descripciones.map((item, index) => {
                                                    return (
                                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                                            <Tarjeta_Detalle_Descripcion item={item}/>
                                                        </Grid>
                                                    )
                                                })}


                                            </Grid>

                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'center'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                                sx={{mt: 4}}
                                                spacing={4}
                                            >

                                                {caractaristicas?.map((item, index) => {
                                                    return (
                                                        <Grid container size={{xs: 6, sm: 6, md: 4}}
                                                              sx={{justifyContent: 'flex-start'}}>
                                                            <Tarjeta_Caracteristicas item={item}/>
                                                        </Grid>
                                                    )
                                                })}

                                            </Grid>


                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'center'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                                sx={{mt: 5}}
                                            >


                                                <Grid container size={{xs: 12, sm: 6, md: 6}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Grid
                                                        container
                                                        justifyContent={'flex-start'}
                                                        alignItems={'flex-start'}
                                                        size={{xs: 12, sm: 12, md: 12}}>

                                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: !masSM ? 32 : 40,
                                                                    fontWeight: 800,
                                                                    lineHeight: 1.1
                                                                }}>
                                                                {`${item.tarifa} UDS`}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid container size={{xs: 12, sm: 12, md: 8}}
                                                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                                            <Typography sx={{fontSize: 12, fontWeight: 500}}>
                                                                Aplican descuentos segun dias de la semana
                                                            </Typography>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>

                                                <Grid container size={{xs: 12, sm: 6, md: 6}}
                                                      sx={{justifyContent: 'flex-end', mt: sCell ? 4 : 0}}>
                                                    <Button
                                                        onClick={() => abrir()}
                                                        color={'info'} fullWidth variant={'contained'}
                                                        sx={{boxShadow: 0}}
                                                        endIcon={<EventAvailable/>}
                                                    >Reservar</Button>
                                                </Grid>


                                            </Grid>


                                        </Grid>
                                    </Grid>


                                </Grid>
                            </Grid>


                        </Grid>


                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{backgroundColor: theme.palette.primary.main}}
                >

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3, pt: 4, pb: 8, height: sCell ? 840 : 220}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Detalle_Portada


const descripciones = [
    {
        img: ic_agua,
        largo: 26,
        nombre: 'El agua tratada con las tecnologías de Nipponflex',
        descripcion: 'Usamos dispositivos como el ARS - Alkaline Recovery System que busca devolverle al agua sus propiedades naturales más beneficiosas para el organismo '
    },
    {
        img: ic_almoada,
        largo: 32,
        nombre: 'Almohadas de Nipponflex diseñadas para mejorar la calidad del descanso',
        descripcion: 'basándose en conceptos de la medicina preventiva oriental y la tecnología japonesa.'
    },
]

